import { Button, Center, Loader, Text } from "@mantine/core";
import { IconPrinter } from "@tabler/icons-react";
import { useQuery } from "@tanstack/react-query";
import { useEffect } from "react";
import { Link, useParams } from "react-router";
import { publicCvQuery } from "../api/queries";
import { EmptyState } from "../components/empty-state";
import { Logo } from "../components/logo";
import { FitCv } from "../cv/fit";
import { useMessages } from "../i18n/provider";
import styles from "./public-cv.module.css";

export function PublicCvPage() {
  const t = useMessages();
  const { slug = "" } = useParams();
  const { data, isLoading, isError } = useQuery(publicCvQuery(slug));

  useEffect(() => {
    if (!data) return;
    const name = data.document.profile.fullName || data.document.title;
    document.title = `${name} — YourCV`;
    return () => {
      document.title = "YourCV";
    };
  }, [data]);

  if (isLoading) {
    return (
      <Center h="100dvh">
        <Loader size="sm" color="gray" />
      </Center>
    );
  }

  if (isError || !data) {
    return (
      <Center h="100dvh" px="md">
        <EmptyState
          title={t("public.notFound")}
          action={
            <Button component={Link} to="/" variant="light">
              {t("app.name")}
            </Button>
          }
        />
      </Center>
    );
  }

  return (
    <div className={styles.root}>
      <header className={styles.bar}>
        <Logo to="/" />
        <Button
          size="compact-sm"
          variant="default"
          leftSection={<IconPrinter size={15} stroke={1.5} />}
          onClick={() => window.print()}
        >
          {t("public.print")}
        </Button>
      </header>
      <main className={styles.stage}>
        <div className={styles.paper}>
          <FitCv doc={data.document} branded={data.branded} />
        </div>
        <Text size="xs" c="dimmed" ta="center" mt="lg" className="yc-no-print">
          {t("public.madeWith")}
        </Text>
      </main>
    </div>
  );
}
